import React, { useState, useEffect } from "react";
import { Button, InputNumber, theme } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

function PageNavigationBar({ currentPage, setCurrentPage, numPages, annotations, onAddBookmark }) {
  const [input, setInput] = useState(currentPage);
  const isBookmarked = annotations.some(a => a.type === "bookmark" && a.page === currentPage);

  const {
    token: {
      colorBgContainer,
      colorBorder,
      colorPrimary,
      borderRadiusLG,
      colorTextSecondary,
    },
  } = theme.useToken();

  const handleInput = (value) => setInput(value);

  const jumpToPage = () => {
    const page = Math.max(1, Math.min(numPages, Number(input)));
    setCurrentPage(page);
  };

  useEffect(() => {
    setInput(currentPage);
  }, [currentPage]);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        padding: "8px 16px",
      }}
    >
      <Button
        onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
        disabled={currentPage === 1}
        style={{ marginRight: 8 }}
        icon={<LeftOutlined />}
        aria-label="Previous page"
        size="large"
      />
      <div style={{ display: "flex", alignItems: "center", margin: "0 8px" }}>
        <InputNumber
        size="large"
          min={1}
          max={numPages}
          value={input}
          onChange={handleInput}
          onPressEnter={jumpToPage}
          style={{ width: 48, textAlign: "center", borderRadius: borderRadiusLG }}
        />
        <span style={{ marginLeft: 4, color: colorTextSecondary }}>/ {numPages}</span>
      </div>
      <Button
        onClick={() => setCurrentPage(prev => Math.min(numPages, prev + 1))}
        disabled={currentPage === numPages}
        style={{ marginRight: 8 }}
        icon={<RightOutlined />}
        aria-label="Next page"
        size="large"
      />
      {/* <Button
        type={isBookmarked ? "primary" : "default"}
        onClick={() => onAddBookmark(currentPage)}
        style={{ marginLeft: 8 }}
      >
        {isBookmarked ? "🔖 Bookmarked" : "📑 Add Bookmark"}
      </Button>
      {isBookmarked && (
        <span style={{ marginLeft: 12, fontSize: 20, color: colorPrimary }}>🔖</span>
      )} */}
    </div>
  );
}

export default PageNavigationBar;